export const moveDockToCenter=()=>{
    return{
        type:"moveDockToCenter"
    }
} 


export const moveDockToLeft=()=>{
    return{
        type:"moveDockToLeft"
    }
} 

export const moveDockToRight=()=>{
    return{
        type:"moveDockToRight"
    }
} 


export const disableAutoHideDock=()=>{
    return{
        type:"disableAutoHideDock"
    }
} 

export const enableAutoHideDock=()=>{
    return{
        type:"enableAutoHideDock"
    }
} 